import { useContext } from "react";
import { ColumnDefaultsContext } from "../contexts/ColumnDefaultsContext";

export const useColumnDefaults = () => useContext(ColumnDefaultsContext);
